import { ReactElement } from 'react';
import { toast } from 'react-hot-toast';

import { CartCouponProps } from '~/types/cart';
import { useCart } from '~/lib/cart';
import { useSavedCart } from '~/lib/cart/useCart';

import DealCouponLabel from './DealCouponLabel';

export default function DealActions({
  couponLabel,
  dealId,
}: {
  couponLabel: CartCouponProps['description'];
  dealId: number;
}): ReactElement {
  const { lineItemRemove } = useCart(undefined, true);
  const { saveDeal } = useSavedCart();

  return (
    <div className="mt-2 flex">
      <button
        className="mr-4 text-sm text-grace"
        onClick={async () => {
          if (!(await saveDeal(dealId))) {
            toast.error("You've already saved this deal.");
          }
        }}
      >
        Save for later
      </button>
      <button
        className="text-sm text-grace"
        onClick={async () => {
          if (!(await lineItemRemove(dealId))) {
            toast.error('Sorry, cannot remove this deal, please try again.');
          }
        }}
      >
        Remove
      </button>
      {couponLabel && (
        <div className="grow">
          <div className="hidden items-center justify-end lg:flex">
            <DealCouponLabel couponLabel={couponLabel} />
          </div>
        </div>
      )}
    </div>
  );
}

export { DealActions };
